import trim from "lodash/trim";
import { toBackendWidgetRef } from "report/report-creation/content/types";
import fetchWidgetDetails from "report/report-creation/content/fetchWidgetDetails";
import debounceWithPromise from "views/logic/debounceWithPromise";
import LookupTableParameter from "views/logic/parameters/LookupTableParameter";
const ifNotEmpty = (key, errors) => Object.keys(errors).length > 0 ? { [key]: errors } : {};
const isEmptyString = (s) => !s || trim(s) === "";
const shouldNotBeEmpty = (values, keys) => Object.fromEntries(keys.flatMap((key) => isEmptyString(values == null ? void 0 : values[key]) ? [[key, "Must be specified."]] : []));
export const parameterCanHaveValue = (parameter) => parameter.type !== LookupTableParameter.type;
const validateParameters = (parameters, values) => {
  const parameterWhichRequireValue = Object.values(parameters).flat().filter(parameterCanHaveValue).map(({ name }) => name);
  return shouldNotBeEmpty(values, parameterWhichRequireValue);
};
const validateContent = (widgets, values = []) => {
  const missingWidgets = values.map((value) => {
    if (!widgets[value.widgetId]) {
      return "Widget is no longer accessible";
    }
    return void 0;
  });
  if (!missingWidgets.filter((error) => error).length) {
    return {};
  }
  return { widgets: missingWidgets };
};
const validateReportForm = async (values) => {
  const widgetRefs = values.widgets.map(toBackendWidgetRef);
  const widgetDetails = await fetchWidgetDetails(widgetRefs);
  const generalErrors = shouldNotBeEmpty(values, ["title"]);
  const deliveryErrors = values.delivery.active ? shouldNotBeEmpty(values == null ? void 0 : values.delivery, ["email_body", "email_subject"]) : {};
  const parameterErrors = validateParameters(widgetDetails.parameters, values.parameterValues);
  const contentErrors = validateContent(widgetDetails.widgets, values.widgets);
  return {
    ...contentErrors,
    ...generalErrors,
    ...ifNotEmpty("delivery", deliveryErrors),
    ...ifNotEmpty("parameterValues", parameterErrors)
  };
};
const debouncedValidateReportForm = debounceWithPromise(validateReportForm, 350);
export default debouncedValidateReportForm;
